import {Templates} from './Templates.js';

export class UserLogin extends HTMLElement {
	constructor() {
		super();
		[this.el, this.$] = Templates(`UserLogin`);
		this.attachShadow({mode:'open'});
		this.shadowRoot.appendChild(this.el);
		this.$.username_container.addEventListener(`click`, evt=>{
			this.classList.toggle(`dropdown`);
		});
	}
	connectedCallback() {
		const user = this.getAttribute(`user`);
		if (!user) {
			this.classList.add(`not_logged_in`);
			this.$.login_url.setAttribute(`href`, this.getAttribute(`login_url`));
			return;
		}
		this.classList.add(`logged_in`);
		this.$.username.innerText = user;
		if (this.hasAttribute(`admin_url`)) {
			this.$.admin_url.setAttribute(`href`, this.getAttribute(`admin_url`));
		} else {
			this.$.admin_url.remove();
		}
		this.$.logout_url.setAttribute(`href`, this.getAttribute(`logout_url`));
	}
}
customElements.define(`lateral-user`, UserLogin);